(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    class SlideBlock {
    constructor(block) {
      this.block = block;
      this.slideContent = block.querySelector('.slide__content');
      this.init();
    }

    init() {
      // Aquí puedes agregar tu lógica de JavaScript personalizada
      // Ejemplo: agregar event listeners, animaciones, etc.
      this.blockId = this.block.dataset.blockId;
      this.handleSlideInteractions();
    }

    handleSlideInteractions() {
      // Agrega tus eventos aquí
      // Ejemplo: click listeners, scroll listeners, etc.
    }
  }

  // Inicializar bloques cuando se cargan
  document.querySelectorAll('[data-block-id]').forEach(block => {
    if (block.classList.contains('slide__content')) {
      new SlideBlock(block);
    }
  });

  // Para bloques cargados dinámicamente (Shopify Theme Editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', (event) => {
      const block = event.target.closest('[data-block-id]');
      if (block && block.classList.contains('slide__content')) {
        new SlideBlock(block);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_stats-counter"] && !Shopify.designMode) return;
  try {
    class StatsCounter extends HTMLElement {
    connectedCallback() {
      if (this.dataset.observed) return;
      this.dataset.observed = 'true';
      const target = this.querySelector('[data-counter-target]');
      if (!target) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        target.textContent = target.dataset.counterTarget;
        return;
      }
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.dataset.revealed) {
            this.dataset.revealed = 'true';
            this.animate(target);
            io.unobserve(this);
          }
        });
      }, { threshold: 0.3 });
      io.observe(this);
    }

    animate(el) {
      const raw = el.dataset.counterTarget;
      const target = parseFloat(raw);
      if (isNaN(target)) { el.textContent = raw; return; }
      const duration = parseInt(el.dataset.counterDuration) || 1800;
      const decimals = (raw.split('.')[1] || '').length;
      const start = performance.now();
      const tick = (now) => {
        const t = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - t, 3);
        const current = target * eased;
        el.textContent = decimals > 0
          ? current.toFixed(decimals)
          : Math.floor(current).toLocaleString();
        if (t < 1) requestAnimationFrame(tick);
        else el.textContent = decimals > 0
          ? target.toFixed(decimals)
          : target.toLocaleString();
      };
      requestAnimationFrame(tick);
    }
  }

  if (!customElements.get('stats-counter')) {
    customElements.define('stats-counter', StatsCounter);
  }
  } catch(e) { console.error(e); }
})();

})();
